module.exports = __webpack_public_path__ + "static/media/check-in-circle.b7b9e617.svg";